import { useCallback, useMemo, useState } from "react";
import { NotificationItem } from "../types";
import {
  addIncomingNotification,
  createInitialNotificationsState,
  getUnreadNotificationsCount,
  hydrateNotificationsFromItems,
  markAllNotificationsAsRead,
  markNotificationAsRead,
} from "../utils/notificationStore";

export const useNotificationsStore = () => {
  const [state, setState] = useState(createInitialNotificationsState);

  const addNotification = useCallback(
    (envelope: unknown, wireEventName?: string) => {
      setState((current) => addIncomingNotification(current, envelope, wireEventName));
    },
    []
  );

  const markAsRead = useCallback((id: string) => {
    setState((current) => markNotificationAsRead(current, id));
  }, []);

  const markAllAsRead = useCallback(() => {
    setState((current) => markAllNotificationsAsRead(current));
  }, []);

  const hydrateFromApi = useCallback((items: NotificationItem[]) => {
    setState(hydrateNotificationsFromItems(items));
  }, []);

  const unreadCount = useMemo(() => getUnreadNotificationsCount(state), [state]);

  return {
    notifications: state.items,
    unreadCount,
    addNotification,
    markAsRead,
    markAllAsRead,
    hydrateFromApi,
  };
};
